import request, { type CustomAxiosRequestConfig } from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { File } from "@zhihaoscm/entity";

// 文件服务
export class FileService extends BaseService<unknown, unknown, unknown, unknown> {
    public async uploadFile(params: FormData, requestConfig?: CustomAxiosRequestConfig): Promise<File> {
        const { data } = await request.service.post(`/dataService/admin/file/upload`, params, {
            timeout: 0,
            ...requestConfig
        });
        return data;
    }
    /* 上传文件并获取预签名URL */
    public async uploadFilePreSign(params: FormData): Promise<File> {
        const { data } = await request.service.post(`/dataService/admin/file/pre-sign/upload`, params);
        return data;
    }
    public async getFileById(id: number): Promise<File> {
        const { data } = await request.service.get(`/dataService/admin/file/${id}`);
        return data;
    }
    public async getFileByIds(ids: number[]): Promise<File[]> {
        const { data } = await request.service.post(`/dataService/admin/file/ids`, ids);
        return data;
    }

    public async getTemplate(id: number): Promise<string> {
        const { data } = await request.service.get(`/dataService/admin/file/download/template/${id}`);
        return data;
    }

    // 无需鉴权的批量获取
    public async getWithoutRoleIds(ids: number[]): Promise<File[]> {
        const { data } = await request.service.post(`/dataService/admin/file/withoutRole/ids`, ids);
        return data;
    }
}
export const fileService = new FileService("", request.service, { cancel: true });
